<template>
  <!-- Model Preview-->
  <div
    class="modal fade p-0"
    id="imagemodal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-on:keyup="keyHandler($event)"
  >
    <div class="modal-dialog col-10 pl-0 pr-0 m-0">
<!--    <div class="modal-dialog col-10 pl-0 pr-0 mt-1">-->
      <div class="spinner-cover" style="display: block;">
        <div class="spinner"></div>
      </div>
      <div class="modal-content PhotoXXL">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" style="position: absolute; top:10px; right: 10px;">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>

          <div id="image_container" class="d-none">
            <div class="slide text-center">
              <img class="xxl_photo_view"/>
            </div>
          </div>

          <div id="xxl_canvas_div" class="canvas_div" style="height:100%; max-height: 90vh; max-width:90vw; margin-left: auto; margin-right:auto;">
            <canvas ref="xxlcanvas" id="canvass"></canvas>
          </div>


          <a href="#" @click="toLeft" v-if="!hideImageShift">
            <img  src="@/assets/images/pdarrow_left.png" width="40" class="XXL_view_left_arrow" alt="next-image"/>
          </a>
          <a href="#" @click="toRight" v-if="!hideImageShift">
            <img src="@/assets/images/pdarrow_right.png" width="40" class="XXL_view_right_arrow" alt="next-image"/>
          </a>
        </div>
        <div class="simple-photo-option photo-modal-infos">
          <ul>
            <li>Nr. {{currentModalPhoto.runid}}</li>
            <li>|</li>
            <li>{{currentModalPhoto.photodate_c | getDateString()}}</li>
            <li>|</li>
            <li>{{ currentModalPhoto.photodate_c | getTimeString() }} Uhr</li>
          </ul>
        </div>
      </div>
    </div>



  </div>

  <!-- Model Preview END-->
</template>

<script>
import Main from '../photo/components/Main'
import moment from 'moment'
import {mapState} from 'vuex'
import {fabric} from 'fabric'
export default {
  name: "PhotoModal",
  filters: {
    toDEDate: function(datestring) {
      if(!datestring ||datestring == undefined) return ''

      return moment(datestring).format('DD.MM.YYYY HH:mm:ss')
    },
    getDateString: function(datestring) {
      if(!datestring ||datestring == undefined) return ''

      return moment(datestring).format('DD.MM.YYYY')
    },
    getTimeString: function(datestring) {
      if(!datestring ||datestring == undefined) return ''

      return moment(datestring).format('HH:mm:ss')
    }
  },

  props: ["photoIDCollection",'imgSrc'],
  data() {
    return {
      lastX: null,
      lastY: null,
      PhotoID_Array:[],
      photo: [],
      currentphoto: {},
      imageSrc: '',
      canvasref: null,
      canvas: null,
      zoom_value: 3,
      zoomRange: 10,
      zoomLevel: 10,
      hideImageShift: false
    }
  },
  created: function () {
    this.photoArray = this.photo
  },
  computed: {
    ...mapState({
      currentModalPhoto: state => state.photo.currentModalPhoto
    }),
  },

  methods:{

    async loadxxl(photo) {
      let _this = this

      $('#imagemodal').modal('show')
      if (!(this.canvas === null || this.canvas === undefined)) {
        this.canvas.clear()
        this.canvas.dispose()
      }

      this.canvas = _this.createCanvas()

      $('.spinner-cover').show()
      this.$store.state.photo.currentModalPhoto = photo

      const isBase64 = typeof photo === 'string' && photo.startsWith('data:image/');
      if (isBase64) {

        console.log('Image is Base64')
        _this.hideImageShift = true
        setTimeout(function () {
          let canvas = _this.canvas
          // Für Base64 -> Direkt ins Canvas laden
          const image = new Image();
          image.src = photo;


          image.onload = function () {
            const fabricImage = new fabric.Image(image);

            _this.zoom_value = 3
            _this.zoomRange = 10
            _this.zoomLevel = 10
            _this.zoomLevel = 0
            console.log('Bildbreite:', image.width);
            console.log('Bildhöhe:', image.height);

            // Set Canvas Size
            let hgt = document.querySelector('#xxl_canvas_div').offsetHeight
            let hPer = (hgt / image.height) * 100
            let width = (image.width / 100) * hPer
            let canvas_width = document.querySelector('#xxl_canvas_div').offsetWidth
            let hPerForOffset = (hgt / image.height) * 100
            let widthForOffset = (image.width / 100) * hPerForOffset
            _this.offset_left = (canvas_width - widthForOffset) / 2

            console.log('ImageProps', hgt, width, hPerForOffset, widthForOffset)

            canvas.setHeight(hgt)
            canvas.setWidth(width)

            console.log('XXLCanvas setBackground')
            canvas.setBackgroundImage(fabricImage, canvas.renderAll.bind(canvas), {
              centeredRotation: true,
              centeredScaling: true,
              originX: 'middle',
              originY: 'middle',
              backgroundImageStretch: true
            })

            fabricImage.set({
              centeredRotation: true,
              centeredScaling: true,
              originX: 'middle',
              originY: 'middle',
              scaleX: canvas.width / fabricImage.width,
              scaleY: canvas.height / fabricImage.height
            })

            console.log('XXLCanvas setWidth')
            canvas.setWidth(canvas_width)

            console.log('XXLCanvas centerObject')
            canvas.centerObject(fabricImage)
            // _this.canvas = canvas

            console.log('XXLCanvas render')
            canvas.renderAll()






            _this.setEventsOnCanvas(canvas)
            $('.spinner-cover').hide();
          }

        }, 1000)


      } else {

        _this.hideImageShift = false
        // Short duration needed to setup canvas full
        setTimeout(function () {
          _this.getfileImage_xxl(_this.currentModalPhoto)
          $('.spinner-cover').hide()
        }, 1000)

      }
    },



    async getfileImage_xxl (photo) {
      // process.env.VUE_APP_BASE_URL + "getfile/photo/" + photo_id + "/2000x2000/",

      let canvas = this.canvas
      //
      // let canvas = this.createCanvas();

      $('.spinner-cover').show();
      let _this = this
      this.$store.state.photo.currentModalPhoto = photo
      console.log('CurrentPhoto', this.currentphoto, photo)
      let url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.projectid}&id=${photo.pdphotoid}&type=orig&token=${localStorage.sessiontoken}`
      await fetch(
        url,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onload = function() {
            let fotos = reader.result
            this.neuesBase = fotos
            _this.zoom_value = 3
            _this.zoomRange = 10
            _this.zoomLevel = 10
            _this.zoomLevel = 0
            _this.imageSrc = fotos

            // console.log('Current - Fotos', fotos)
            _this.setPhotoInCanvas(fotos)
            // _this.setPhotoInCanvas(canvas , fotos)
            _this.setEventsOnCanvas(canvas)
            // _this.makeCanvas()
            $('.spinner-cover').hide();

            console.log('AfterLoad', _this);

            ///**Insert the ID and src to Image Tag  **/
            // $('.xxl_photo_view').prop('src', fotos)
            // $('.xxl_photo_view').prop('id', photo.pdphotoid)
          }
        })

    },

    createCanvas () {
      console.log('Create Canvas')
      const ref = this.$refs.xxlcanvas
      return new fabric.Canvas(ref, {
        selection: false,
        controlsAboveOverlay: true,
        centeredScaling: true,
        allowTouchScrolling: true,
        hasBorders: false,
        lockRotation: false,
        lockMovement: false,
        lockMovementY: false,
        lockMovementX: false,
        lockUniScaling: false,
        lockScalingY: false,
        lockScalingX: false,
        originX: 'middle',
        originY: 'middle',
        preserveObjectStacking: false,
        pointDragTrue: false,
      })
    },


    // async setPhotoInCanvas (canvas , photo) {
    async setPhotoInCanvas (photo) {
      let _this = this
      let canvas = this.canvas

      await fabric.Image.fromURL(photo, function (img) {
        let hgt = document.querySelector('#xxl_canvas_div').offsetHeight
        // let hgt = document.querySelector('#xxl_canvas_div').
        let hPer = (hgt / img.height) * 100
        let width = (img.width / 100) * hPer
        let canvas_width = document.querySelector('#xxl_canvas_div').offsetWidth
        let hPerForOffset = (hgt / img.height) * 100
        let widthForOffset = (img.width / 100) * hPerForOffset
        _this.offset_left = (canvas_width - widthForOffset) / 2
        canvas.setHeight(hgt)
        canvas.setWidth(width)
        console.log('XXLCanvas setBackground')
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          backgroundImageStretch: true
        })



        console.log('XXLCanvas img.set')
        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height
        })

        console.log('XXLCanvas setWidth')
        canvas.setWidth(canvas_width)

        console.log('XXLCanvas centerObject')
        canvas.centerObject(img)
        // _this.canvas = canvas

        console.log('XXLCanvas render')
        canvas.renderAll()
        //Add events on canvas
      });
    },

    getZoomArea() {

    },

    canvasZoomIn () {
      let obj = this
      console.log('Zoom Before In OBJ', obj)
      console.log('Zoom Before In', obj.zoomRange)
      this.getZoomArea(obj)

      if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
        obj.zoomRange += 10
      }

      // if (obj.zoomRange <= 1000) {
      //   obj.zoomRange = parseInt(obj.zoomRange) + 10
      // }
      console.log('Zoom After In', obj.zoomRange)
    },

    canvasZoomOut () {
      let obj = this
      console.log('Zoom Before Out OBJ', obj)
      console.log('Zoom Before Out', obj.zoomRange)
      this.getZoomArea(obj)

      if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
        obj.zoomRange -= 10
      }

      // if (obj.zoomRange >= -100) {
      //   obj.zoomRange = parseInt(obj.zoomRange) - 10
      // }
      console.log('Zoom After Out', obj.zoomRange)
    },

    //Set a Zoom Level
    setZoomLevel () {
      let obj = this
      let zoom = this.zoomRange
      if (zoom >= 0 && zoom <= 50) {
        obj.zoomLevel = 10
      }
      if (zoom >= 51 && zoom <= 100) {
        obj.zoomLevel = 9
      } else if (zoom >= 101 && zoom <= 150) {
        obj.zoomLevel = 8
      } else if (zoom >= 151 && zoom <= 160) {
        obj.zoomLevel = 7
      } else if (zoom >= 201 && zoom <= 220) {
        obj.zoomLevel = 6
      } else if (zoom >= 251 && zoom <= 270) {
        obj.zoomLevel = 5
      } else if (zoom >= 301 && zoom <= 320) {
        obj.zoomLevel = 4
      } else if (zoom >= 351 && zoom <= 370) {
        obj.zoomLevel = 3
      } else if (zoom >= 401 && zoom <= 430) {
        obj.zoomLevel = 2
      } else if (zoom >= 500 && zoom <= 550) {
        obj.zoomLevel = 1
      }
      console.log('ZL:', obj.zoomLevel)
    },



    async getfileImage_count (photo) {
      // process.env.VUE_APP_BASE_URL + "getfile/photo/" + photo + "/2000x2000/",
      let url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.pdprojectid}&id=${photo.pdphotoid}&type=l&token=${localStorage.sessiontoken}`
      await fetch(
        url,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onload = function() {
            let fotos = reader.result
            this.neuesBase = fotos
            /** set src Attribute to PhotoView **/
            $('.xxl_photo_view').prop('src', fotos)
          }

        })

    },



    // ScrollZoom(container,max_scale,factor){
    //
    //
    //   var target = container.children().first()
    //   var size = {w:target.width(),h:target.height()}
    //   var pos = {x:0,y:0}
    //   var zoom_target = {x:0,y:0}
    //   var zoom_point = {x:0,y:0}
    //   var scale = 1
    //   target.css('transform-origin','0 0')
    //   target.on("mousewheel DOMMouseScroll",scrolled)
    //
    //   function scrolled(e){
    //
    //     console.log('ScrollZoomd', container,max_scale,factor)
    //     var offset = container.offset()
    //     zoom_point.x = e.pageX - offset.left
    //     zoom_point.y = e.pageY - offset.top
    //
    //     e.preventDefault();
    //     var delta = e.delta || e.originalEvent.wheelDelta;
    //     if (delta === undefined) {
    //       //we are on firefox
    //       delta = e.originalEvent.detail;
    //     }
    //     delta = Math.max(-1,Math.min(1,delta)) // cap the delta to [-1,1] for cross browser consistency
    //
    //     // determine the point on where the slide is zoomed in
    //     zoom_target.x = (zoom_point.x - pos.x)/scale
    //     zoom_target.y = (zoom_point.y - pos.y)/scale
    //
    //     // apply zoom
    //     scale += delta*factor * scale
    //     scale = Math.max(1,Math.min(max_scale,scale))
    //
    //     // calculate x and y based on zoom
    //     pos.x = -zoom_target.x * scale + zoom_point.x
    //     pos.y = -zoom_target.y * scale + zoom_point.y
    //
    //
    //     // Make sure the slide stays in its container area when zooming out
    //     if(pos.x>0)
    //       pos.x = 0
    //     if(pos.x+size.w*scale<size.w)
    //       pos.x = -size.w*(scale-1)
    //     if(pos.y>0)
    //       pos.y = 0
    //     if(pos.y+size.h*scale<size.h)
    //       pos.y = -size.h*(scale-1)
    //
    //     update()
    //   }
    //
    //   function update(){
    //     target.css('transform','translate('+(pos.x)+'px,'+(pos.y)+'px) scale('+scale+','+scale+')')
    //   }
    // },
    toRight(){
      // this.ScrollZoom($('#image_container'),4,0.5);
      $('.spinner-cover').show();
      // $('.xxl_photo_view').prop('src', '');


      // let current_photo_id =  $('.xxl_photo_view').attr('id')
      let current_photo_id =  this.currentModalPhoto.pdphotoid
      let current_photo_index = this.photoIDCollection.findIndex((photo) => photo.pdphotoid == current_photo_id)
      let photo_id_next = this.photoIDCollection[current_photo_index+1];

      //
      // for(let i=0; i < this.photoIDCollection.length; i++){
      //   this.PhotoID_Array.push(this.photoIDCollection[i]['id'])
      // }
      // let current_photo_id =  $('.xxl_photo_view').attr('id')
      // let current_photo_key = parseInt(this.PhotoID_Array.indexOf(current_photo_id))
      // let photo_id_next = this.PhotoID_Array[current_photo_key+1];
      if (photo_id_next !== undefined){
        this.getfileImage_xxl(photo_id_next);
        this.PhotoID_Array = [];
      }else{
        $('#imagemodal').modal('hide');
        $('.spinner-cover').hide();
        return false;
      }

    },
    toLeft(){
      // this.ScrollZoom($('#image_container'),4,0.5);
      $('.spinner-cover').show();
      // $('.xxl_photo_view').prop('src', '');

      // let current_photo_id =  $('.xxl_photo_view').attr('id')
      let current_photo_id =  this.currentModalPhoto.pdphotoid
      let current_photo_index = this.photoIDCollection.findIndex((photo) => photo.pdphotoid == current_photo_id)
      let photo_id_prev = this.photoIDCollection[current_photo_index-1];

      // for(let i=0; i < this.photoIDCollection.length; i++){
      //   this.PhotoID_Array.push(this.photoIDCollection[i]['pdphotoid'])
      // }
      //
      // let current_photo = this.PhotoID_Array.findIndex((photo) => photo.pdphotoid == current_photo_id)
      // console.log('current photo array', current_photo_id, current_photo)
      // let photo_id_prev = this.PhotoID_Array[current_photo_key-1];

      if(photo_id_prev !== undefined){
        this.getfileImage_xxl(photo_id_prev)
        this.PhotoID_Array = [];
      }else{
        $('#imagemodal').modal('hide');
        $('.spinner-cover').hide();
        return false;
      }
    },
    /** Function for Keyboard **/
    keyHandler (event) {
      if(event.key=='ArrowLeft'){
        this.toLeft();
      }else if(event.key=='ArrowRight'){
        this.toRight();
      }
    },

    setEventsOnCanvas(canvas) {
      let obj = this

      canvas.on('mouse:wheel', function (opt) {
        if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
          (opt.e.deltaY > 0) ? obj.canvasZoomOut() : obj.canvasZoomIn()
        } else {
          if(obj.zoomRange > 1000) obj.zoomRange = 1000;
          if(obj.zoomRange < 0) obj.zoomRange = 0;
          // obj.zoomRange = 0
        }
      })

      canvas.on('mouse:down', function (e) {
        obj.panning = true
        obj.lastX = obj.lastY = null;
        if (!e.target) {
          //
        }
      })

      canvas.on('mouse:up', function (e) {
        obj.panning = false
        obj.lastX = obj.lastY = null;
        if (!e.target) {
          //
        }
      })

      canvas.on('object:moving', function () {
        // console.log('Canvas- MouseMoving', obj)
        obj.panning = false
        //
      })

      canvas.on('mouse:move', function (e) {
        if (obj.panning && e && e.e) {
          if (e.e.type === 'mousemove'){
            // console.log('Canvas- MouseMove', obj.panning, e, e.e)
            let delta = new fabric.Point(e.e.movementX, e.e.movementY)
            canvas.relativePan(delta)
            let canvasViewPort = canvas.viewportTransform

            let bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
            if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
              canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
            }
            let rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
            if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
              canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
            }
          }else {
            obj.touchMoveEvent(e.e.touches[0],canvas)
          }
        }
      })
    },

    touchMoveEvent(touch,canvas){
      if (this.lastX && this.lastY) {
        const delta = new fabric.Point(touch.clientX - this.lastX, touch.clientY - this.lastY)
        canvas.relativePan(delta)
        const canvasViewPort = canvas.viewportTransform

        const bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
        if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
          canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
        }
        const rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
        if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
          canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
        }
      }
      this.lastX = touch.clientX;
      this.lastY = touch.clientY;
    },
  },
  watch: {
    'photo': function(photo) {
      console.log('SetCurrentPhoto', photo)
      this.currentphoto = photo
    },
    // Add Canvas
    'zoomRange': async function () {
      let obj = this
      if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
        let canvas = obj.canvas
        let c = (obj.zoomRange / 55) + 1
        canvas.zoomToPoint({x: canvas.getWidth() / 2, y: canvas.getHeight() / 2}, c)
        canvas.setZoom(c)
        await obj.canvas.getObjects().forEach(await function (point) {
          if (point.get('type') === 'group') {
            obj.setPointsZoom(obj.zoomRange, point)
          }
        })
        obj.imagesPopup = false
        obj.selectedFlagPhoto = null
        canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
        // Change The Zoom Level By Changing The Zoom
        obj.setZoomLevel()
      }
    },

    'zoomLevel': async function () {
      let obj = this
      let c = obj.canvas
      c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/PhotoModal.vue